import { render, staticRenderFns } from "./EducationPlan.vue?vue&type=template&id=3f12dfb6&"
import script from "./EducationPlan.vue?vue&type=script&lang=js&"
export * from "./EducationPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports